import { ConfirmClientInvitationPage } from './confirm-client-invitation'

export const ConfirmClientInvitationStack = {
  ConfirmClientInvitationPage,
}
